import React, { useState, useRef, useEffect } from 'react';
import videojs from 'video.js';
import "video.js/dist/video-js.css";
import IconButton from '@material-ui/core/IconButton';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import download from 'downloadjs';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { getTimezoneOffset } from 'date-fns-tz';

const aws =  require('aws-sdk');


const mobileCheck = () =>  {
	let check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	// console.log("mobile check", check);
	return check;
};

export default function AWSCameraViewer2({
    currentLocation,
    videoDateTime,
    setVideoDateTime,
    isPlaying,
    setIsPlaying,
    camera,
    speed,
    fastForwardCount,
    rewindCount,
    fullScreen,
    setFullScreen,
    isLive,
    setIsLive,
    grid,
    resizeCounter,
    ind,
    updateCanPlay,
}){

    const videoRef = useRef(); // points to actual video Dom object
    const playerRef = useRef(); // used to keep track of video js player object
	const canvasRef = useRef();
	const wrapperRef = useRef();
	const snapshotRef = useRef();
	const dateTimeRef = useRef(new Date(1999, 1, 1)); // set arbitrary impossible date
	const [player, setPlayer] = useState();

    const VIDEO_LENGTH = 90; // in minutes

    // Config AWS
    aws.config.update({
		region: 'us-west-2',
		credentials: {
			accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
			secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
		}
	});

	const kinesisOptions = {
		// ON_DEMAND - media playlist is typically static for sessions, LIVE - media playlist is continually updated with new fragments for sessions 
		PlaybackMode: 'LIVE',
		// NEVER /ALWAYS 
		DisplayFragmentTimestamp: 'ALWAYS',
		// how much time link is valid in seconds, this value can be between 300 (5 minutes) and 43200 (12 hours).
		Expires: 600, // 10 min
		// FRAGMENTED_MP4 - container format packages the media into MP4 fragments, MPEG_TS - only supported packaging on older HLS players, has a 5-25 % consts more 
		ContainerFormat: 'FRAGMENTED_MP4',
		// ALWAYS - recommended to use if fragment timestamps are not accurate,and server timestamp is selected, NEVER - option for producer timestamp, ON_DISCONTINUITY - adviced option for most cases, media player timeline is only reset when there is a significant issue with the media timeline (e.g. a missing fragment)
		DiscontinuityMode: 'ALWAYS',
		HLSFragmentSelector: {
			// PRODUCER_TIMESTAMP, SERVER_TIMESTAMP
			FragmentSelectorType: 'SERVER_TIMESTAMP',
		},
	};

    const kinesisVideo = new aws.KinesisVideo();
    const kinesisVideoArchivedContent = new aws.KinesisVideoArchivedMedia(); // new might not work
	
	async function getLiveStream(streamName) {
		// creating video stream endpoint
		const endpointObject = await kinesisVideo.getDataEndpoint({
			StreamName : streamName,
			APIName: 'GET_HLS_STREAMING_SESSION_URL',
		}).promise();
	
		if(endpointObject.DataEndpoint) {
			const data = {
				//get stream session url, url is valid from 5 min to 12 h. depending on hereabove options
				url : await getStreamSessionURL(endpointObject.DataEndpoint, streamName, kinesisOptions),
			}
			return data
		} else {
			throw new Error('Cannot get the url');
		}
	}


    /**
     * Helper function to get the start and time time in the correct
     * timezone based on the videoDateTime prop and the currentLocation timezone
     */
    const getStreamTimes = () => {
        /**
         * So, it appears that if we do SERVER_TIMESTAMP, if will do cali 
         * So we need to make sure we are converting the local timestamp to
         * cali time
         */
        // Get the time 
        // For testing just use a set time
        // let d = new Date(2022, 3, 28, 0, 0);
        let d = new Date(videoDateTime);
        console.log(d);
        console.log(videoDateTime);
        let localOffset = -1 * d.getTimezoneOffset() * 60 * 1000;
        let baseOffset = getTimezoneOffset("America/Los_Angeles");
        console.log("Localoffset", localOffset);
        console.log("Base offset", baseOffset)

        let adjusted = new Date(d.valueOf() - (baseOffset - localOffset));
        console.log("Adjusted Start", adjusted);

        const VIDEO_LENGTH_MS = VIDEO_LENGTH * 60 * 1000;
        let adjustedEnd = new Date(adjusted.valueOf() + VIDEO_LENGTH_MS);

        return {
            startTime: adjusted,
            endTime: adjustedEnd
        }
        // Create timestamp 
    }

    async function getHistoricalStream(streamName){

        const { startTime, endTime } = getStreamTimes();

        // creating video stream endpoint
		const endpointObject = await kinesisVideo.getDataEndpoint({
			StreamName : streamName,
			APIName: 'GET_HLS_STREAMING_SESSION_URL',
		}).promise();


        // Define options for historical
        let historicalOptions = {
            // ON_DEMAND - media playlist is typically static for sessions, LIVE - media playlist is continually updated with new fragments for sessions 
            PlaybackMode: 'ON_DEMAND',
            // PlaybackMode: "LIVE_REPLAY",
            // NEVER /ALWAYS 
            DisplayFragmentTimestamp: 'ALWAYS',
            // how much time link is valid in seconds, this value can be between 300 (5 minutes) and 43200 (12 hours).
            Expires: 600, // 10 min
            // FRAGMENTED_MP4 - container format packages the media into MP4 fragments, MPEG_TS - only supported packaging on older HLS players, has a 5-25 % consts more 
            ContainerFormat: 'FRAGMENTED_MP4',
            // ALWAYS - recommended to use if fragment timestamps are not accurate,and server timestamp is selected, NEVER - option for producer timestamp, ON_DISCONTINUITY - adviced option for most cases, media player timeline is only reset when there is a significant issue with the media timeline (e.g. a missing fragment)
            DiscontinuityMode: 'ALWAYS',
            MaxMediaPlaylistFragmentResults: 5000,
            HLSFragmentSelector: {
                // PRODUCER_TIMESTAMP, SERVER_TIMESTAMP
                FragmentSelectorType: 'SERVER_TIMESTAMP',
                TimestampRange: {
                    // StartTimestamp: new Date(2022, 3, 24, 3, 0),
                    // EndTimestamp: new Date(2022, 3, 24, 5, 0)
                    StartTimestamp: startTime,
                    EndTimestamp: endTime
                }
            },
        };


        if(endpointObject.DataEndpoint) {
			const data = {
				//get stream session url, url is valid from 5 min to 12 h. depending on hereabove options
				url : await getStreamSessionURL(endpointObject.DataEndpoint, streamName, historicalOptions),
			}
			return data
		} else {
			throw new Error('Cannot get the url');
		}
    }
	
	async function getStreamSessionURL(endpoint, streamName, options) {
		// https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/KinesisVideoArchivedMedia.html
		const kinesisVideoArchivedMedia = new aws.KinesisVideoArchivedMedia({
			region: 'us-west-2',
			endpoint: new aws.Endpoint(endpoint)
		})
		
		// get HLSS sourse of the stream as will use HLSS player. Other option is DASH - getDASHStreamingSessionURL
		const data = await kinesisVideoArchivedMedia.getHLSStreamingSessionURL({
			StreamName: streamName,
			...options,
		}).promise();

		return data.HLSStreamingSessionURL
	};

    const downloadVideo = async () => {
        console.log("Download");
        const endpointObject = await kinesisVideo.getDataEndpoint({
			StreamName : "27_0",
			APIName: 'GET_HLS_STREAMING_SESSION_URL',
		}).promise();


        // Define options for historical
        let historicalOptions = {
            "ClipFragmentSelector": { 
                "FragmentSelectorType": "SERVER_TIMESTAMP",
                "TimestampRange": { 
                   "EndTimestamp": new Date(2022, 3, 28, 1, 2),
                   "StartTimestamp": new Date(2022, 3, 28, 0, 0)
                }
             },
        };
        console.log(historicalOptions);

        if (endpointObject.DataEndpoint){

            const kinesisVideoArchivedMedia = new aws.KinesisVideoArchivedMedia({
                region: 'us-west-2',
                endpoint: new aws.Endpoint(endpointObject.DataEndpoint)
            })
            console.log("Made it here");
            console.log(kinesisVideoArchivedMedia)
            
            // get HLSS sourse of the stream as will use HLSS player. Other option is DASH - getDASHStreamingSessionURL
            kinesisVideoArchivedMedia.getClip({
                StreamName: "27_0",
                ...historicalOptions,
            }, (err, data) => {
                console.log("inside here");
                // download("test", "test.txt", "text/plain");
                console.log(data);
                console.warn(err);
                // download(data.Payload, "test_download.mp4", 'video/mp4');
                let blob = new Blob([data.Payload], {type: 'video/mp4'});
                // console.log("Made a blob");
                // console.log(blob);
                download(blob, "test.mp4", 'video/mp4');
            })

            console.log("We are here?");
        }
    }


    // Effect Hooks ------------------------------------------------------------
    // On Load
    useEffect(() => {
        // create palyer
        const p = playerRef.current = videojs(
            videoRef.current, {
                autoplay: true,
                muted: true,
                playsinline:true, 
                controls: true,
                preload: 'auto',
                userActions: {
                    click: false
                },
                html5: {vhs:{overrideNative:true}}
            }
        );

        // Add listeners
        p.on("fullscreenchange", () => {
            if (p.isFullscreen()){
                setFullScreen()
            }
        });

        p.on("loadedmetadata", (e) => {
			let w = wrapperRef.current.clientWidth;
			p.width(w);
		})

        p.on("play", () => {
            setIsPlaying(true);
        })

        p.on("pause", () => {
            setIsPlaying(false);
        })

        p.on('canplay', () => {
            updateCanPlay(true, ind);
        })

        if (mobileCheck()){
            p.on('error', () => {
                console.error("Video player error");
                p.load();
                p.play();
            });
        }


        /**
         * When the clip ends, we need to fastforward the videoDateTime
         * by the length of the clip
         */
        // p.on('ended', () => {
        //     console.log("Video ended, changing datetime");
        //     setVideoDateTime(videoDateTime.valueOf() + (VIDEO_LENGTH * 60 * 1000));
        // })
        // I think this actuall yneeds to be in videoDateTime effect

        let _resize = () => {
            if (p){
                let w = wrapperRef.current.clientWidth;
                p.width(w);
            }
        }
        window.addEventListener('resize', _resize);

        setPlayer(p);

        // cleanup
        return () => {
            if (player){
                player.dispose();
            }
            if (p){
                p.dispose();
            }
            window.removeEventListener('resize', _resize);
        }
    }, []);


    // On player and datetime
    useEffect(() => {
        if (player !== undefined && videoDateTime !== undefined){
            console.log("IS LIVE", isLive);
            if (isLive){
                goToLive();
                return;
            }

            // Else not live, get stream URL for specified date time;
            goToHistorical();

            // Set the ended event for the video to go to get next playlist

            // This is a resource
            // https://docs.aws.amazon.com/kinesisvideostreams/latest/dg/hls-playback.html#how-hls-ex1
        }
    }, [player, videoDateTime]);

    useEffect(() => {
        if (player !== undefined){
            if (isLive){
                goToLive();
            }
            else{
                goToHistorical();
            }
        }
    }, [player, isLive]);

    /**
	 * Play or pause the video based on isPlaying prop
	 */
	useEffect(() => {
		if (mobileCheck()){return}
		if (player){
			if (isPlaying){
				player.play();
			}
			else{
				player.pause();
			}
		}
	}, [isPlaying])

    useEffect(() => {
        if (player){
            try{
                player.playbackRate(speed);
                player.defaultPlaybackRate(speed);
            }
            catch{
                console.warn("error changing speed");
            }
        }
    }, [speed])

    useEffect(() => {
        if (player){
            player.currentTime(player.currentTime() + (5 * 60));
        }
    }, [fastForwardCount]);

    useEffect(() => {
        if (player){
            player.currentTime(player.currentTime() - (5 * 60));
        }
    }, [rewindCount]);

    // Resize timeout (just to make sure we get a pic to load metadata first)
    useEffect(() => {
        let tid = setTimeout(resize, 400);
        return () => clearTimeout(tid);
    }, [grid, resizeCounter])


    // -------------------------------------------------------------------------
    
    const resize = () => {
        if (player){
            let w = wrapperRef.current.clientWidth;
            player.width(w);
        }
    }


    const goToLive = async () => {
        if (player !== undefined && player !== null){
            try{
                let streamInfo = await getLiveStream(`${currentLocation.id}_${camera}`);
                console.log(streamInfo);
                console.log(player);
                // setPlayerSource(streamInfo.url);
                player.src({
                    src: streamInfo.url,
                    type: "application/x-mpegURL"
                });
                player.playbackRate(1);
                player.defaultPlaybackRate(1);
            }
            catch {
                console.log("not working, darn");
            }  
        }
    }

    const goToHistorical = async () => {
        if (player !== undefined && player !== undefined){
            try{
                console.log("HERE SETTING ON ENDED");
                player.on('ended', () => {
                    setVideoDateTime(videoDateTime.valueOf() + (VIDEO_LENGTH * 60 * 1000));
                })
                let streamInfo = await getHistoricalStream(`${currentLocation.id}_${camera}`);
                console.log(streamInfo);
                // setPlayerSource(streamInfo.url);
                player.src({
                    src: streamInfo.url,
                    type: "application/x-mpegURL"
                });
            }
            catch{
                console.warn("Error in goToHistorical");
                setIsLive(true);
                window.alert("This location does not have historical video that far back, you will be re-directed to live");

            }
        }

    }

    const setPlayerSource = (srcURL) => {
        if (player === undefined || player === null){
            return
        }
        player.src({
            src: srcURL,
            type: "application/x-mpegURL"
        });
    }



    // Helpers -----------------------------------------------------------------
    const snapshot = () => {
		// set the canvas dimensions
		canvasRef.current.width = videoRef.current.videoWidth;
		canvasRef.current.height = videoRef.current.videoHeight;
		canvasRef.current.getContext('2d').drawImage(videoRef.current, 0, 0, 
					videoRef.current.videoWidth, videoRef.current.videoHeight);
		canvasRef.current.toBlob( (blob) => {
			download(blob, 'snapshot.jpg', 'img/jpeg');
		} );

	}

    const mobileCheck = () =>  {
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		// console.log("mobile check", check);
		return check;
	};
    // -------------------------------------------------------------------------

    const dateTest = () => {

    }

    return(
		<>
			<div className='flow-root'>
				<h3 className='m-3 float-left'>Camera: {camera}</h3>
				<div className={`float-right pr-3 pt-3 ${mobileCheck() ? 'hidden' : ''}`}>
					<IconButton onClick={snapshot}  ref={snapshotRef} size='small'>
						<CameraAltIcon className='cameraIcon'/>
					</IconButton>
                    {/* <button onClick={downloadVideo}>
                        Download
                    </button> */}
				</div>
			</div>
			<div data-vjs-player ref={wrapperRef} className='overflow-hidden rounded-b-lg'>
				<TransformWrapper>
					<TransformComponent>
						<video
							controls // <--------------- we want to get rid of these when dev is donen
							muted
							playsInline
							autoPlay
							ref={videoRef}
							className="video-js"
							>
						</video>
					</TransformComponent>
				</TransformWrapper>
			</div>
			<canvas id="canvas" style={{"overflow":"auto", 'display':'none'}} ref={canvasRef}></canvas>
			

		</>
	)
}